import localforage from "localforage";


const class8Record = localforage.createInstance({
    drivers : [localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE],
    name: "SMS",
    storeName: "class8Record"
});


const setClass8Record = (key, value) => {
  // console.log("setClass8Record----->",key, value);
  class8Record.setItem(key, value);
      
        };
  
  
        const getClass8Record = (key) => {
          // console.log("getClass8Record----->",key);
          class8Record.getItem(key).then(function () {
                      // console.log("CHECKING RESPONSE GET ITEM:",class8Record.getItem(key));
                    }).then(function (value) {
                      // we got our value
                    }).catch(function (err) {
                      // we got an error
                    });  
              
                };
  
        
  
  
      export {getClass8Record, setClass8Record};



  //   const getclass8Record = async (key) => {
//     console.log("getclass8Record----->",key);
//     try {
//         const value = await localforage.getItem(key);
//         // This code runs once the value has been loaded
//         // from the offline store.
//         console.log(value);
//     } catch (err) {
//         // This code runs if there were any errors.
//         console.log(err);
//     }
     
    
//       };
  

//   try {
//     const value = await localforage.getItem('somekey');
//     // This code runs once the value has been loaded
//     // from the offline store.
//     console.log(value);
// } catch (err) {
//     // This code runs if there were any errors.
//     console.log(err);
// }
